import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState: any = {};

export const authSlice = createSlice({
  name: "users",
  initialState: initialState,
  reducers: {},
});
